<template>
  <div :class="boxesClasses">
    <svg class="box top" width="185.38" height="61.25" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 185.38 61.25"><path d="M185.38 61.25a18.31 18.31 0 0 0-9.16-15.86L101.84 2.45a18.31 18.31 0 0 0-18.31 0L9.16 45.4A18.31 18.31 0 0 0 0 61.25" fill="#32bec8" fill-rule="evenodd"/></svg>
    <div
      :style="boxStyle"
      class="box middle"
    >
      <span class="percentage"><slot></slot></span>
    </div>
    <svg class="box bottom" width="185.38" height="61.25" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 185.38 61.25"><path d="M0 0a18.31 18.31 0 0 0 9.16 15.86L83.53 58.8a18.31 18.31 0 0 0 18.31 0l74.37-42.94A18.31 18.31 0 0 0 185.38 0" fill="#32bec8" fill-rule="evenodd"/></svg>
  </div>
</template>

<script>
export default {
  name: 'Box',
  props: {
    percentage: {
      type: Number,
      required: true
    },
    startAnimation: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    boxesClasses () {
      return {
        'boxes': true,
        'start': this.startAnimation
      }
    },
    boxStyle () {
      return {
        'max-height': this.startAnimation ? `${this.percentage}px` : '0px',
        height: `${this.percentage}px`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.boxes {
  left: 0;
  right: 0;
  top: 29px;
  position: absolute;
  font-size: 0;
  text-align: center;
  opacity: 0;
}

.start {
  opacity: 0.8;
  transition: opacity 1000ms ease;
}

.box {
  margin: 0 auto;
}

.middle {
  background-color: #32bec8;
  width: 185.38px;
  margin-top: -1px;
  margin-bottom: -1px;
  transition: max-height 1000ms ease;
}

.top {
  top: 0;
}

.bottom {
  bottom: 0;
}

.percentage {
  font-size: 39px;
  font-weight: $fw-bold;
  line-height: 1;
  color: white;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  text-align: center;
}
</style>
